import { Environment } from '../enums';

export interface TokenConfig {
  developmentDecimals: number;
  productionDecimals: number;
}

export interface TokenDecimalConfig {
  GALA: TokenConfig;
  USDC: TokenConfig;
  USDT: TokenConfig;
  ETH: TokenConfig;
  BSC: TokenConfig;
  USD_VALUE: TokenConfig;
}

export interface TokenDecimals {
  GALA_DECIMAL: number;
  USDC_DECIMAL: number;
  USDT_DECIMAL: number;
  ETH_DECIMAL: number;
  BSC_DECIMAL: number;
  USD_VALUE_DECIMAL: number;
}

export function createTokenDecimals(environment: Environment): TokenDecimals {
  const config: TokenDecimalConfig = {
    GALA: { developmentDecimals: 18, productionDecimals: 18 },
    USDC: { developmentDecimals: 18, productionDecimals: 18 },
    USDT: { developmentDecimals: 18, productionDecimals: 18 },
    ETH: { developmentDecimals: 18, productionDecimals: 18 },
    BSC: { developmentDecimals: 18, productionDecimals: 18 },
    USD_VALUE: { developmentDecimals: 8, productionDecimals: 8 },
  };

  return {
    GALA_DECIMAL: environment === Environment.DEV ? config.GALA.developmentDecimals : config.GALA.productionDecimals,
    USDC_DECIMAL: environment === Environment.DEV ? config.USDC.developmentDecimals : config.USDC.productionDecimals,
    USDT_DECIMAL: environment === Environment.DEV ? config.USDT.developmentDecimals : config.USDT.productionDecimals,
    ETH_DECIMAL: environment === Environment.DEV ? config.ETH.developmentDecimals : config.ETH.productionDecimals,
    BSC_DECIMAL: environment === Environment.DEV ? config.ETH.developmentDecimals : config.ETH.productionDecimals,
    USD_VALUE_DECIMAL:
      environment === Environment.DEV ? config.USD_VALUE.developmentDecimals : config.USD_VALUE.productionDecimals,
  };
}
